import { Avatar, Box } from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import Headline from '../../Components/Headline/Headline';
import Content from '../../Components/Content/Content';
import ReceiptForm from '../../Forms/ReceiptForm';

function Create() {
    return <Content>
        <Box
            sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                <StorefrontIcon />
            </Avatar>
            <Headline size="h5">Bon erfassen</Headline>
            <ReceiptForm />
        </Box>
    </Content>
}

export default Create;
